import React from 'react';
import { Paper } from '@mui/material';
import CheckLine, { PasswordValidationItem } from './CheckLine';
import { styled } from '@mui/material/styles';

type PasswordLiveCheckProps = {
  show: boolean;
  password: string;
  config: Array<PasswordValidationItem>;
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  padding: 16,
  backgroundColor: theme.palette.background.default,
  width: 300,
  marginTop: 8,
  zIndex: 50,
  opacity: 1,
}));

const PasswordLiveCheck: React.FC<PasswordLiveCheckProps> = ({ show, password, config }) => {
  if (!show) {
    return null;
  }
  return (
    <StyledPaper>
      {config.map((item, index) => (
        <CheckLine key={`validation_${index}`} item={item} password={password} />
      ))}
    </StyledPaper>
  );
};

export default PasswordLiveCheck;
